import React, { useState } from 'react';
import { Icon } from '@gumtree/ui-library';
import { useFeatureValue } from '@growthbook/growthbook-react';

import { BannerBackground, BannerClose, BannerContainer, BannerContent } from './banner.style';

const Banner = () => {
    const [hideBanner, setHideBanner] = useState<boolean>(false);
    const defaultValue = '-';
    const vUpMessage = useFeatureValue('v-up', defaultValue);
    const shouldShowBanner = !hideBanner && vUpMessage && vUpMessage !== defaultValue;
    
    if (!shouldShowBanner) {
        return null;
    }
    return (
        <BannerBackground>
            <BannerContainer>
                <BannerContent>
                    <h1>
                        {vUpMessage}
                    </h1>
                </BannerContent>
                <BannerClose
                    className="icn-clear"
                    type="button"
                    onClick={() => {
                        setHideBanner(true);
                    }}
                >
                    <Icon type="clear" />
                </BannerClose>
            </BannerContainer>
        </BannerBackground>
    );
};

export default Banner;
